import AuthService from '@/services/auth.service';
import AdminService from "@/services/admin.service";

const user = JSON.parse(localStorage.getItem('user'));

const initialState = user ? {
    status: {loggedIn: true},
    user,
    email: (JSON.parse(atob(user.token.split(".")[1]))).username,
    role: (JSON.parse(atob(user.token.split(".")[1]))).roles[0],
    userData: {},
    completedCoursesCount: 0,
    pathCount: 0,
    coursesCount: 0,
    pathsNames: [],
    pathsByName: [],
    notifications: [],
} : {
    status: {loggedIn: false},
    user: null,
    email: '',
    role: '',
    userData: {},
    completedCoursesCount: 0,
    pathCount: 0,
    coursesCount: 0,
    pathsNames: [],
    pathsByName: [],
    notifications: [],
};

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({commit}, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        getUserData({commit, state}) {
            return AdminService.getCurrentUser(state.email).then(
                userData => {
                    commit('setUserData', userData);
                    if (userData.paths && userData.paths.length < 10) {
                        commit("setPathCount", "0" + userData.paths.length);
                    } else if (userData.paths) {
                        commit("setPathCount", userData.paths.length);
                    }
                    let count = 0
                    if (userData.paths) {
                        userData.paths.map(path => {
                            count = count + (path.courses.length)
                        })
                    }
                    if (count < 10) {
                        count = "0" + count;
                    }
                    commit("setCoursesCount", count)
                    let names = [];
                    if (userData.paths) {
                        userData.paths.map(path => {
                            if (!names.includes(path.name.toUpperCase())) {
                                names.push(path.name.toUpperCase())
                            }
                        })
                    }
                    commit("setPathsNames", names);
                    if (userData.paths && userData.paths.length) {
                        const paths = new Set();
                        userData.paths.forEach(path => paths.add(path.name));
                        commit("setPathsByName", Array.from(paths));
                    }
                    return Promise.resolve(userData);
                },
            );
        },
        getCompletedCoursesCount({commit, state}) {
            return AdminService.getCompletedCoursesCount(state.email).then(
                data => {
                    commit('setCompletedCoursesCount', data);
                    return Promise.resolve(data);
                },
            );
        },
        getNotifications({commit, state}) {
            return AdminService.getNotifications(state.email).then(
                data => {
                    commit('setNotifications', data);
                    return Promise.resolve(data);
                },
            );
        },
        logout({commit}) {
            AuthService.logout();
            commit('logout');
        },
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
            state.email = (JSON.parse(atob(user.token.split(".")[1]))).username;
            state.role = (JSON.parse(atob(user.token.split(".")[1]))).roles[0];
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.email = '';
            state.role = '';
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.email = '';
            state.role = '';
        },
        setUserData(state, data) {
            state.userData = data;
        },
        setPathCount(state, data) {
            state.pathCount = data;
        },
        setCoursesCount(state, data) {
            state.coursesCount = data;
        },
        setPathsNames(state, data) {
            state.pathsNames = data;
        },
        setPathsByName(state, data) {
            state.pathsByName = data;
        },
        setCompletedCoursesCount(state, data) {
            state.completedCoursesCount = data;
        },
        setNotifications(state, data) {
            state.notifications = data;
        }
    },
    getters: {
        loggedIn: (state) => state.status.loggedIn,
        role: (state) => state.role,
        email: (state) => state.email,
        userData: (state) => state.userData,
        completedCoursesCount: (state) => state.completedCoursesCount,
        pathCount: (state) => state.pathCount,
        coursesCount: (state) => state.coursesCount,
        pathsNames: (state) => state.pathsNames,
        pathsByName: (state) => state.pathsByName,
        notifications: (state) => state.notifications,
    }
};
